module.exports = __webpack_public_path__ + "static/media/IMG_20210110_212238_853.8af2ae79.jpg";